module.exports = __webpack_public_path__ + "media/site_templates/www.rangehood-installation.com.au/images/testimonials-f54912e946bdfbc147d6be5969b14aba.jpg";